import { useMutation } from '@apollo/client';

import {
    CREATE_SURVEY,
    REASSIGN_SURVEY_CHAMPION,
    CANCEL_SURVEY,
    UPDATE_SURVEY_ITEM_PRICE,
    BULK_UPDATE_SURVEY_ITEM_PRICES,
    SUBMIT_SURVEY_TO_DIVISIONAL_MANAGER,
    GENERATE_SURVEY_PROOF_UPLOAD_URLS,
    CREATE_PROOF_OF_SURVEY_COMPETITOR_PRICING,
    DELETE_SURVEY_COMPETITOR_PROOF,
    SYNC_SURVEY_COMPETITOR_PRICES,
    PREPOPULATE_SURVEY_COMPETITOR_PRICES,
    PREPOPULATE_SURVEY_DM_REVIEW,
} from '../../apollo/mutations/survey';
import { GET_PROOF_OF_SURVEY_COMPETITOR_PRICING } from '../../apollo/queries/survey';

export type {
    CreateSurveyInput,
    SurveyProductInput,
} from '../../codegen/graphql';

const CREATE_SURVEY_REFETCH_OPERATION_NAMES = [
    'GetSurveys',
    'GetSurveyCounts',
] as const;

export function useCreateSurvey() {
    return useMutation(CREATE_SURVEY, {
        refetchQueries: [...CREATE_SURVEY_REFETCH_OPERATION_NAMES],
        awaitRefetchQueries: true,
    });
}

export function useReassignSurveyChampion() {
    return useMutation(REASSIGN_SURVEY_CHAMPION);
}

export function useCancelSurvey() {
    return useMutation(CANCEL_SURVEY, {
        refetchQueries: ['GetSurveys', 'GetSurveyCounts', 'GetSurvey'],
        awaitRefetchQueries: true,
    });
}

export function useUpdateSurveyItemPrice() {
    return useMutation(UPDATE_SURVEY_ITEM_PRICE);
}

export function useBulkUpdateSurveyItemPrices() {
    return useMutation(BULK_UPDATE_SURVEY_ITEM_PRICES);
}

export function useSubmitSurveyToDivisionalManager() {
    return useMutation(SUBMIT_SURVEY_TO_DIVISIONAL_MANAGER);
}

export function useGenerateSurveyProofUploadUrls() {
    return useMutation(GENERATE_SURVEY_PROOF_UPLOAD_URLS);
}

export const useCreateProofOfSurveyCompetitorPricing = () => {
    return useMutation(CREATE_PROOF_OF_SURVEY_COMPETITOR_PRICING, {
        refetchQueries: [GET_PROOF_OF_SURVEY_COMPETITOR_PRICING],
    });
};

export function useDeleteSurveyCompetitorProof() {
    return useMutation(DELETE_SURVEY_COMPETITOR_PROOF, {
        refetchQueries: [GET_PROOF_OF_SURVEY_COMPETITOR_PRICING],
    });
}

export function useSyncSurveyCompetitorPrices() {
    return useMutation(SYNC_SURVEY_COMPETITOR_PRICES);
}

export function usePrepopulateSurveyCompetitorPrices() {
    return useMutation(PREPOPULATE_SURVEY_COMPETITOR_PRICES);
}

export function usePrepopulateSurveyDmReview() {
    return useMutation(PREPOPULATE_SURVEY_DM_REVIEW);
}
